import React, { useEffect, useState } from 'react';

import './heart-rating.scss'


const HeartRating = ({ rate, ratingsNumber, readOnly, setRateUser }) => {

    const [rating, setRating] = useState(rate ? rate: 1);//doble check when readOnly is false
    const [hover, setHover] = useState(null);

    useEffect(() => {
        if (!readOnly) {
            setRateUser(rate)
        }
    }, [])

    const setRatingUser = (ratingValue) => {
        if (!readOnly) {
            setRateUser(ratingValue)
        }
        setRating(ratingValue)

    }

    return (
        <div className="f-a-HeartRating">
            {readOnly ?
                [...Array(5)].map((heart, index) => {
                    const ratingValue = index + 1;

                    return (
                        <div key={index}
                            className={"f-a-HeartRating__heart-readOnly " + (ratingValue <= rate ? "f-a-HeartRating__heart-active" : "f-a-HeartRating__heart")}>
                        </div>
                    )
                })
                :
                [...Array(5)].map((heart, index) => {
                    const ratingValue = index + 1;

                    return (
                        <div
                            className={ratingValue <= (hover || rating) ? "f-a-HeartRating__heart-active" : "f-a-HeartRating__heart"}
                            onClick={() => setRatingUser(ratingValue)}
                            onMouseEnter={() => setHover(ratingValue)}
                            onMouseLeave={() => setHover(null)}
                            key={index}
                        >
                        </div>
                    )
                })
            }<div className="f-a-HeartRating__rating-number">({ratingsNumber})</div>
        </div>
    )
}
HeartRating.defaultProps = {
    setRateUser: () => { }
};

export default HeartRating
